import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserRoutingModule } from './user-routing.module';
import { UserSearchComponent } from './pages/user-search/user-search.component';
import { LaaSSharedModule } from 'src/app/shared/laas-shared.module';
import { UserStatusPipe } from './pipes/user-status.pipe';
import { UserModifyComponent } from './pages/user-modify/user-modify.component';
import { UserPreviewComponent } from './pages/user-preview/user-preview.component';
import { ActivatedPipe } from './pipes/activated.pipe';
import { RolePermissionComponent } from './pages/role-permission/role-permission.component';
import { RoleComponent } from './pages/role/role.component';
import { PasswordChangeComponent } from './pages/password-change/password-change.component';
import { UserDataPermissionComponent } from './pages/user-data-permission/user-data-permission.component';
import { UserSubscribtionPermissionComponent } from './pages/user-subscribtion-permission/user-subscribtion-permission.component';
import { NotificationSubscribtionModule } from '../notification-subscribtion/notification-subscribtion.module';


@NgModule({
  declarations: [
    UserSearchComponent,
    UserStatusPipe,
    UserModifyComponent,
    UserPreviewComponent,ActivatedPipe, RolePermissionComponent, RoleComponent, PasswordChangeComponent,
    UserDataPermissionComponent,
    UserSubscribtionPermissionComponent
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    LaaSSharedModule,
    NotificationSubscribtionModule
  ],
  exports:[
    UserPreviewComponent
  ]

})
export class UserModule { }
